import * as React from 'react';
import { Component } from 'react';
import MainLayout from '../../layouts/MainLayout';
import * as _ from 'lodash';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { setPlusActions } from '../../redux/actions/general/plus';
import styles from '../../styles/views/plans/PlanUploads.scss';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import {
  __,
  dateFrom,
  getActiveStage,
  getURLParam,
  guessPaperSize,
  ptToMm,
  redirect,
  setTableParams,
} from '../../core/utils';
import Table from '../../components/Table';
import {
  changePlanOCRProcessingStatus,
  changePlanStatus,
  deletePlanUploads,
  listPlanUploads,
  publishPlanUploads,
  readPlanUpload,
  rotatePlanUpload,
} from '../../redux/actions/table/plan_uploads';
import {
  leaveChannel,
  listenPlanProcessingStatusChanged,
} from '../../core/sockets';
import { setNotification } from '../../redux/actions/general/notification';
import SendIcon from '../../assets/images/send-16x16.svg';
import { getTeamsPermissions } from '../../redux/actions/table/teams';
import Tooltip from '../../components/Tooltip';
import PlanUploadsFlyout from '../../flyouts/plan_uploads/PlanUploadsFlyout';
import { withRouter } from 'react-router';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import OCRIcon from '../../assets/images/ocr-16x16.svg';
import TagIcon from '../../assets/images/tag-16x16.svg';
import ScaleIcon from '../../assets/images/scale-16x16.svg';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import TableNA from '../../components/TableNA';
import Avatar from '../../components/Avatar';
import Image from '../../components/Image';

const mapStateToProps = (state) => {
  return {
    table: state.table['plan_uploads'],
    auth: state.auth,
    rotation: _.get(state.table, ['plan_uploads', 'rotation'], 0),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.plan_uploads/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
@withRouter
class PlanUploads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team_roles: [],
    };
  }

  componentWillUnmount() {
    leaveChannel('plan_uploads.' + this.props.match.params.stage);
  }

  componentDidMount() {
    getTeamsPermissions(this.props.match.params.stage).then(({ response }) => {
      this.setState({ team_roles: _.get(response.data, 'teams', {}) });

      listenPlanProcessingStatusChanged(
        this.props.match.params.stage,
        (plan_id, processed) => {
          changePlanStatus(plan_id, processed);

          if (processed == 1 && plan_id == this.props.table.clicked_row) {
            readPlanUpload(this.props.table.clicked_row).then(
              ({ response }) => {
                this.setState({ preview: response.data });
              }
            );
          }

          if (_.includes(_.map(this.props.table.data, 'id'), plan_id)) {
            listPlanUploads(this.props.match.params.stage);
          }
        }
      );

      window.Echo.private(
        'plan_uploads.' + this.props.match.params.stage
      ).listen('PlanOCRProcessingStatusChanged', ({ plan_id, status }) => {
        changePlanOCRProcessingStatus(plan_id, status);

        listPlanUploads(this.props.match.params.stage);

        if (
          status != _.get(this.state, 'preview.ocr_processing') &&
          plan_id == this.props.table.clicked_row
        ) {
          readPlanUpload(this.props.table.clicked_row).then(({ response }) => {
            this.setState({ preview: response.data });
          });
        }
      });

      enableProjectsDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plans/uploads')
      );
      enableStagesDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plans/uploads')
      );

      createSidebar({
        title: __('submenu.title.plans'),
        items: [
          {
            title: __('submenu.title.current-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/current',
          },
          {
            title: __('submenu.title.working-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/working',
          },
          {
            title: __('submenu.title.uploads'),
            active: true,
            items: [
              {
                title: __('submenu.title.uploads-list'),
                link: () => '/stages/' + getActiveStage() + '/plans/uploads',
                active: true,
              },
              {
                title: __('submenu.title.ocr-templates'),
                link: () => '/stages/' + getActiveStage() + '/ocr_templates',
              },
            ],
          },
          {
            title: __('submenu.title.deliveries'),
            link: () => '/stages/' + getActiveStage() + '/deliveries',
          },
          {
            title: __('submenu.title.approvals'),
            link: () => '/stages/' + getActiveStage() + '/approvals',
          },
        ],
      });

      !_.isEmpty(this.state.team_roles.editor) &&
        setPlusActions([
          {
            title: __('button.upload-plans'),
            onClick: () =>
              this.props.actions.setTableParams({
                wizard_active: true,
              }),
          },
        ]);
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.table.clicked_row !== prevProps.table.clicked_row) {
      if (
        prevProps.table.clicked_row &&
        prevProps.rotation != 0 &&
        _.includes([90, 180, 270], (prevProps.rotation + 360) % 360)
      ) {
        rotatePlanUpload(
          prevProps.table.clicked_row,
          (prevProps.rotation + 360) % 360
        ).then(() => {
          setNotification(
            __('A plan has been rotated and queued for processing.')
          );

          changePlanStatus(prevProps.table.clicked_row, 0);
        });
      }

      if (this.props.table.clicked_row) {
        if (!prevProps.table.clicked_row) {
          this.setState({ preview: undefined });
        }

        readPlanUpload(this.props.table.clicked_row).then(({ response }) => {
          setTableParams('plan_uploads', { rotation: 0 });
          this.setState({ preview: response.data });
        });
      }
    }
  }

  _handleOpacity(value, row) {
    return row.status == '1' ? (
      value
    ) : (
      <div className={styles.hidden}>{value}</div>
    );
  }

  render() {
    const columns = [
      {
        key: 'code',
        name: __('plans.table.title.code'),
        width: 200,
        fullWidth: true,
        value: (code, row) => (
          <span className={styles.ocr_column}>
            {row.existing ? (
              <Tooltip text={__('plans.tooltip.plan-code-exists-in-stage')}>
                <span className={styles.existing}>{code}</span>
              </Tooltip>
            ) : (
              code
            )}
            {row.code_auto ? (
              <Tooltip text={__('plans.tooltip.auto-generated-by-ocr')}>
                <OCRIcon />
              </Tooltip>
            ) : (
              ''
            )}
          </span>
        ),
      },
      {
        key: 'thumb',
        name: __('plans.table.thumbnail'),
        value: (value, row) =>
          this._handleOpacity(
            row.thumbnail_url ? (
              <Tooltip
                placement='right'
                text={
                  <Image
                    className={styles.thumbPreview}
                    src={row.thumbnail_url}
                  />
                }
                html={true}
                dark={true}
              >
                <Image className={styles.thumb} src={row.thumbnail_url} />
              </Tooltip>
            ) : (
              <TableNA />
            ),
            row
          ),
        width: 50,
        sortable: false,
      },
      {
        key: 'title',
        name: __('plans.table.title.title'),
        required: true,
        fullWidth: true,
        value: (title, row) => (
          <span className={styles.ocr_column}>
            {title}
            {row.title_auto ? (
              <Tooltip text={__('plans.tooltip.auto-generated-by-ocr')}>
                <OCRIcon />
              </Tooltip>
            ) : (
              ''
            )}
          </span>
        ),
      },
      {
        key: 'discipline',
        name: __('plans.deliveries.columns.disciplines'),
        value: (discipline, row) => (
          <Tooltip
            text={[
              row.discipline.code,
              row.discipline.id == null
                ? row.discipline.description + '*'
                : _.get(this.props.localization.disciplines, [
                    row.discipline.id,
                    'name',
                  ]),
            ].join(': ')}
          >
            {row.discipline.code}
          </Tooltip>
        ),
        width: 60,
      },
      {
        key: 'team',
        name: __('plans.deliveries.columns.team'),
        value: (team) => team.company,
        width: 100,
      },
      {
        key: 'size',
        name: __('plans.table.title.size'),
        value: (size, row) =>
          row.width == 0 && row.height == 0 ? (
            <TableNA />
          ) : (
            <Tooltip
              text={
                guessPaperSize(ptToMm(row.width), ptToMm(row.height))
                  .description
              }
            >
              {guessPaperSize(ptToMm(row.width), ptToMm(row.height)).size}
            </Tooltip>
          ),
        width: 80,
      },
      {
        key: 'scale',
        name: __('plans.table.title.scale'),
        width: 80,
        fullWidth: true,
        value: (scale, row) => (
          <span className={styles.ocr_column}>
            {_.join([_.toNumber(row.scale1), _.toNumber(row.scale2)], ':')}
            {row.scale_auto ? (
              <Tooltip text={__('plans.tooltip.auto-generated-by-ocr')}>
                <OCRIcon />
              </Tooltip>
            ) : (
              ''
            )}
          </span>
        ),
      },
      {
        key: 'created_at',
        name: __('plans.current-set.tab.revisions.uploaded-at'),
        default: true,
        desc: true,
        value: (value) => (value ? dateFrom(value) : <TableNA />),
        width: 80,
      },
      {
        key: 'created_by',
        name: __('plans.current-set.tab.revisions.uploaded-by'),
        value: (user) => (
          <Avatar
            avatar_url={user.avatar_url}
            name={user.fullname}
            active={user.active}
          />
        ),
        width: 50,
      },
      {
        key: 'status',
        name: __('plans.current-set.tab.status'),
        value: (status, row) =>
          row.ocr_processing ? (
            <div className={styles.processing}>
              {__('plans.status.ocr-processing')}
            </div>
          ) : (
            <>
              {status === 0 && (
                <div className={styles.processing}>
                  {__('plans.status.processing-plan')}
                </div>
              )}
              {status === 1 && (
                <div className={styles.processed}>
                  {__('plans.status.ready-for-publishing')}
                </div>
              )}
              {status === '' && (
                <div className={styles.queued}>
                  {__('plans.status.queued-for-processing')}
                </div>
              )}
            </>
          ),
        sortable: false, //TODO - this must be sortable
        width: 170,
      },
    ];

    const singleActions = (plan_id) => {
      const processed = _.get(
        _.find(this.props.table.data, { id: plan_id }),
        'status'
      );
      const ocr_processing = _.get(
        _.find(this.props.table.data, { id: plan_id }),
        'ocr_processing'
      );

      const actions =
        processed && !ocr_processing
          ? [
              <Tooltip
                text={__('plans.tooltip.icon.plan-publish')}
                key={_.uniqueId()}
              >
                <SendIcon
                  onClick={(e) => {
                    e.stopPropagation();

                    if (
                      _.isEmpty(
                        _.get(
                          _.find(this.props.table.data, { id: plan_id }),
                          'code'
                        )
                      )
                    ) {
                      setNotification({
                        text: __('plans.uploads.notification.missing-number'),
                        type: 'warning',
                      });
                    } else if (
                      _.get(
                        _.find(this.props.table.data, { id: plan_id }),
                        'existing'
                      ) == true
                    ) {
                      setNotification({
                        text: __(
                          'plans.uploads.notification.code-existing-disallow-publish'
                        ),
                        type: 'warning',
                      });
                    } else {
                      publishPlanUploads([plan_id]).then(() => {
                        setNotification(
                          __('plans.uploads.notification.published')
                        );
                        listPlanUploads(this.props.match.params.stage);

                        this.props.actions.setTableParams({
                          actioned_row: undefined,
                        });
                      });
                    }
                  }}
                />
              </Tooltip>,
              <Tooltip
                text={__('plans.tooltip.icon.ocr-plan')}
                key={_.uniqueId()}
              >
                <OCRIcon
                  onClick={(e) => {
                    e.stopPropagation();

                    this.props.actions.setTableParams({
                      ocr_plans_wizard: [plan_id],
                    });
                  }}
                />
              </Tooltip>,
            ]
          : [];

      actions.push(
        <Tooltip text={__('Delete plan upload')} key={_.uniqueId()}>
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();

              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description:
                  'Do you really want to delete the selected plan?\nThis process cannot be undone.',
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-delete'),
                    onClick: () => {
                      deletePlanUploads([plan_id]).then(() => {
                        hideAlertbox();

                        setNotification(
                          __('The selected plan upload has been deleted.')
                        );
                        listPlanUploads(this.props.match.params.stage);

                        this.props.actions.setTableParams({
                          actioned_row: undefined,
                        });
                      });
                    },
                  },
                ],
              });
            }}
          />
        </Tooltip>
      );

      return actions;
    };

    const groupActions = (plan_ids) => [
      <Tooltip text={__('Multiple edit plan scale')} key={_.uniqueId()}>
        <ScaleIcon
          onClick={() =>
            this.props.actions.setTableParams({
              wizard_multiple_plan_scale_edit: plan_ids,
            })
          }
        />
      </Tooltip>,
      <Tooltip text={__('Multiple edit plan tags')} key={_.uniqueId()}>
        <TagIcon
          onClick={() =>
            this.props.actions.setTableParams({
              wizard_multiple_plan_tags_edit: plan_ids,
            })
          }
        />
      </Tooltip>,
      <Tooltip text={__('plans.tooltip.icon.plan-publish')} key={_.uniqueId()}>
        <SendIcon
          onClick={(e) => {
            e.stopPropagation();

            if (
              _.size(
                _.filter(
                  this.props.table.data,
                  (plan) =>
                    _.includes(plan_ids, plan.id) && _.isEmpty(plan.code)
                )
              ) >= 1
            ) {
              setNotification({
                text: __('plans.uploads.notification.missing-number'),
                type: 'warning',
              });
            } else if (
              _.size(
                _.filter(
                  this.props.table.data,
                  (plan) =>
                    _.includes(plan_ids, plan.id) && plan.existing == true
                )
              ) >= 1
            ) {
              setNotification({
                text: __(
                  'plans.uploads.notification.codes-existing-disallow-multiple-publish'
                ),
                type: 'warning',
              });
            } else if (
              _.size(
                _.filter(
                  this.props.table.data,
                  (plan) =>
                    _.includes(plan_ids, plan.id) &&
                    (plan.status !== 1 || plan.ocr_processing)
                )
              ) >= 1
            ) {
              setNotification({
                text: __('plans.uploads.notification.still-processing'),
                type: 'warning',
              });
            } else {
              publishPlanUploads(plan_ids).then(() => {
                setNotification(__('plans.uploads.notification.published'));
                listPlanUploads(this.props.match.params.stage);

                this.props.actions.setTableParams({
                  selected_rows: [],
                });
              });
            }
          }}
        />
      </Tooltip>,
      <Tooltip text={__('plans.tooltip.icon.ocr-plans')} key={_.uniqueId()}>
        <OCRIcon
          onClick={(e) => {
            e.stopPropagation();

            if (
              _.size(
                _.filter(
                  this.props.table.data,
                  (plan) =>
                    _.includes(plan_ids, plan.id) &&
                    (plan.status !== 1 || plan.ocr_processing)
                )
              ) >= 1
            ) {
              setNotification({
                text: __('plans.uploads.notification.ocr-still-processing'),
                type: 'warning',
              });
            } else {
              this.props.actions.setTableParams({
                ocr_plans_wizard: plan_ids,
              });
            }
          }}
        />
      </Tooltip>,
      <Tooltip text={__('Delete selected plan uploads')} key={_.uniqueId()}>
        <DeleteIcon
          onClick={(e) => {
            e.stopPropagation();

            showAlertbox({
              color: 'red',
              title: __('general.alert.are-you-sure'),
              description: __(
                'plans.plan-uploads.warning.want-delete-these-plans.this-process-cannot-undone'
              ),
              buttons: [
                {
                  color: 'lightGray',
                  text: __('general.alert.no-close'),
                  onClick: 'close',
                },
                {
                  color: 'gray',
                  text: __('general.alert.yes-delete'),
                  onClick: () => {
                    deletePlanUploads(plan_ids).then(() => {
                      hideAlertbox();

                      setNotification(
                        __('The selected plan uploads have been deleted.')
                      );
                      listPlanUploads(this.props.match.params.stage);

                      this.props.actions.setTableParams({
                        selected_rows: [],
                      });
                    });
                  },
                },
              ],
            });
          }}
        />
      </Tooltip>,
    ];

    const preview = (
      <PlanUploadsFlyout
        data={_.get(this.state, 'preview', {})}
        readAction={(id) => {
          return new Promise((resolve) => {
            readPlanUpload(getURLParam('id') || id).then(({ response }) => {
              this.setState({ preview: response.data });

              resolve(response);
            });
          });
        }}
      />
    );

    const gridOptions = {
      section: 'Plans',
      image: (id, row) => row.status === 1 && row.thumbnail_url,
      title: (row) => row.code,
      rightTitle: (row) =>
        row.ocr_processing ? (
          <div className={styles.circleO}>O</div>
        ) : (
          <>
            {row.status === 0 && <div className={styles.circleP}>P</div>}
            {row.status === 1 && <div className={styles.circleR}>R</div>}
            {row.status === '' && <div className={styles.circleQ}>Q</div>}
          </>
        ),
      subTitle: (row) => row.title,
      content: (row) => [
        dateFrom(row.created_at) + ' by ' + row.created_by.fullname,
        (row.width == 0 && row.height == 0
          ? ''
          : guessPaperSize(ptToMm(row.width), ptToMm(row.height)).size +
            ' (' +
            guessPaperSize(ptToMm(row.width), ptToMm(row.height)).description +
            ') | ') +
          _.join([_.toNumber(row.scale1), _.toNumber(row.scale2)], ':'),
      ],
    };

    return (
      <Table
        listAction={() => listPlanUploads(this.props.match.params.stage)}
        name='plan_uploads'
        title={__('submenu.title.uploads-list')}
        columns={columns}
        preview={get(this.state, 'preview') ? preview : []}
        singleActions={singleActions}
        groupActions={groupActions}
        gridOptions={gridOptions}
        defaultView='grid'
        onLoad={() => listActiveModules()}
      />
    );
  }
}

export default PlanUploads;
